module.exports = __webpack_public_path__ + "img/no-img.792ed5a.svg";